export class FileAttachmentEntity {
  constructor({url}) {
    this._url = url
  }

  static create({url}) {
    return new FileAttachmentEntity({url})
  }

  toJSON() {
    return {url: this._url}
  }
}
